<template>
  <a-layout class="create-application-box">
    <a-card class="create-application" :bordered=false>
      <div slot="title" v-if="pageLayout.pageTitle">
        <a-icon style="cursor:pointer;" type="left-circle" @click="back" />
        <div>{{pageLayout.pageTitle}}</div>
      </div>
      <div v-for="(layout,index) in pageLayout.contents" :key="index" v-if="loadedInfo && loadedLayout ">
        <common-form v-if="layout.type==='commonForm'" :ref="`commonForm_${layout.field}`" :layout="layout" :params="layout.field && params[layout.field]?params[layout.field]:{}" :can-edit="canEdit" :need-id="true" @changed-fields="onFieldChange"></common-form>
        <upload v-if="layout.type==='upload'" :layout="layout" :default-file-none="defaultFillNone" :params="params[layout.field]?params[layout.field]:[]" :can-edit="canEdit" @changed-fields="onFieldChange"></upload>
        <adjust-table v-if="layout.type==='budgetAdjustTable'" :layout="layout" :columns="columns" :edit-columns="editColumns" :param="layout.initFinished?params[layout.field]:[]" :can-edit="canEdit" @update-data="updateTable"></adjust-table>
        <a-divider/>
      </div>
      <approval-flow :params="approvalFlowInfo" :init-text="'必填信息填写后，流程将自动显示'" v-if="loadedInfo && loadedLayout"></approval-flow>
      <a-row style="margin:30px 0 24px;" v-if="loadedInfo && loadedLayout">
        <a-col :xs="24" :sm="4"></a-col>
        <a-col :xs="24" :sm="10">
          <a-button type="primary" style="width:120px;margin-right: 18px" :disabled="!canSubmit" @click="submit">提交</a-button>
          <a-button @click="visibleComment = true" style="width:120px;">评论</a-button>
        </a-col>
      </a-row>
      <div style="text-align:center" v-else>
        <a-spin tip="数据加载中..."></a-spin>
      </div>
      <comment-and-copy :visible="visibleComment" @cancel="visibleComment = false" @reload="reload"></comment-and-copy>
    </a-card>
  </a-layout>
</template>

<script>
import moment from "moment";
import UUID from "uuidjs";
import LayoutConfig from "../../utils/LayoutConfig.js";
import { data } from "../../data/mockData.js";
import { layoutConfig, mockParams } from "../../utils/mockData.js";
import AdjustTable from "../../components/AdjustTable.vue";
import CommonForm from "../../components/CommonForm.vue";
import ApprovalFlow from "../../components/ApprovalFlow.vue";
import Upload from "../../components/Upload.vue";
import {
  UpdateData,
  COLUMNS,
  getBudgetChangeLayout,
  getBudgetChangeDetailParams,
  getBudgetApprovalFlow,
  createBudgetApplication,
  getBudgetChangeDetailInfo
} from "../../services/BudgetChangeService.js";

export default {
  components: {
    AdjustTable,
    CommonForm,
    ApprovalFlow,
    Upload
  },
  props: {},
  data() {
    return {
      columns: COLUMNS,
      dataSource: [],
      editColumns: COLUMNS.slice(2, COLUMNS.length - 1).map(item => ({
        dataIndex: item.dataIndex, //表格列key， month1,month2...
        month: item.title, //表格列名，2020-01,2020-02...
        monthNum: moment(item.title).month() //对应月份，0,1,2...
      })),
      breadcrumb: [
        {
          label: "发起申请",
          path: ""
        }
      ],
      defaultFillNone: false,
      canEdit: true,
      pageLayout: {},
      params: {},
      loadedLayout: false,
      loadedInfo: false,
      approvalFlowInfo: [],
      requestParams: {},
      cancelSource: null,
      canSubmit: true,
      visibleComment: false
    };
  },
  created() {
    this.fetchParams().then(() => {
      this.fetchLayout();
    });
    const data = {
      basicInfo: {
        applier_info: "",
        change_group_info: ""
      },
      budgetInfo: []
    };
  },

  methods: {
    // 更新预算表格数据
    updateData(data) {
      UpdateData(data);
      this.requestParams = _.cloneDeep(this.params);
    },
    updateTable(e) {
      this.params[e.field] = e.data;
      UpdateData(this.params[e.field]);
      this.requestParams = _.cloneDeep(this.params);
    },
    back() {
      this.$router.replace({
        name: "launchApplication"
      });
    },
    onFieldChange(e) {
      this.params = Object.assign({}, this.params, e);
      LayoutConfig.setAllParams(this.params);
      this.requestParams = _.cloneDeep(this.params);
    },
    cancelQuest() {
      if (typeof this.cancelSource === "function") {
        this.cancelSource("终止请求"); //取消请求
      }
    },
    fetchApprovalFlow() {
      this.approvalFlowInfo = [];
      this.cancelQuest();
      const requestParams = _.cloneDeep(this.requestParams);
      requestParams.budgetInfo = getBudgetChangeDetailInfo(
        requestParams.budgetInfo
      );
      getBudgetApprovalFlow(requestParams, this).then(res => {
        if (res.status === "success") {
          if (res.data && _.isArray(res.data)) {
            res.data.forEach((item, index) => {
              this.$set(this.approvalFlowInfo, index, item);
            });
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    submit() {
      let validateResult = true;
      Object.keys(this.$refs).forEach(key => {
        if (key.indexOf("commonForm") || key.indexOf("multiForm")) {
          this.$refs[key].forEach(item => {
            if (!item.validateFields()) {
              validateResult = false;
            }
          });
        }
      });
      const requestParams = _.cloneDeep(this.requestParams);
      requestParams.budgetInfo = getBudgetChangeDetailInfo(
        requestParams.budgetInfo
      );
      if (validateResult) {
        this.canSubmit = false;
        createBudgetApplication(requestParams).then(res => {
          if (res.status === "success") {
            this.$Message.success("修改申请成功");
            this.$router.replace({
              name: "myApplicationList",
              query: {
                apply_type: 6
              }
            });
          } else {
            this.$Message.error(res.message);
          }
          this.canSubmit = true;
        });
      }
    },
    fetchLayout() {
      this.loadedLayout = false;
      getBudgetChangeLayout({ id: this.$route.query.id, type: "create" }).then(
        res => {
          if (res.status === "success") {
            this.pageLayout = res.data;
            this.pageLayout.contents.forEach(item => {
              if (item.type === "budgetAdjustTable") {
                item.initFinished = false;
                this.updateData(this.params[item.field]); // 预算调整表格数据格式化
                this.requestParams = _.cloneDeep(this.params);
                this.fetchApprovalFlow();
                item.initFinished = true;
              }
            });
            this.loadedLayout = true;
          } else {
            this.$Message.error(res.message);
          }
        }
      );
    },
    fetchParams() {
      this.loadedInfo = false;
      return getBudgetChangeDetailParams({
        id: this.$route.query.id,
        type: "detail"
      }).then(res => {
        if (res.status === "success") {
          this.params = res.data;
          this.loadedInfo = true;
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    reload() {
      this.visibleComment = false;
      this.fetchApprovalFlow();
    }
  }
};
</script>

<style lang="less">
</style>
